import { Box, Typography } from "@mui/material";

import { theme } from "../../../mui-customs/Theme";

interface HourlyRateIconProps {
  hourlyRate: number;
}

export const HourlyRateIcon = ({ hourlyRate }: HourlyRateIconProps) => {
  return (
    <Box
      sx={{
        "& p": {
          fontFamily: "Roboto",
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "32px",
          display: "inline-block",
        },
      }}
    >
      <Typography sx={{ color: "primary.main" }}>$</Typography>
      <Typography
        sx={{ color: hourlyRate > 51 ? "primary.main" : theme.brand1[200] }}
      >
        $
      </Typography>
      <Typography
        sx={{ color: hourlyRate > 76 ? "primary.main" : theme.brand1[200] }}
      >
        $
      </Typography>
      <Typography
        sx={{ color: hourlyRate > 101 ? "primary.main" : theme.brand1[200] }}
      >
        $
      </Typography>
    </Box>
  );
};
